import { Button, ButtonType, colors, sizing } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

export function FooterButtons(props) {
  const {
    backButton = {
      isDisabled: false,
      name: 'Back',
    },
    buttons = [],
  } = props;

  // HOOKS
  // Reouter
  const history = useHistory();

  return (
    <DefaultBarWrapper>
      <Buttons>
        {buttons.length > 0 &&
          buttons.map((button) => (
            <Button
              key={button.name}
              disabled={button.isDisabled}
              loading={button.loading}
              onClick={button.handleClick}
              text={button.name}
              type={ButtonType.PRIMARY}
            />
          ))}
        <Button
          key="back"
          disabled={backButton.isDisabled}
          onClick={() => history.push('/administration/study_protocols')}
          text={backButton.name}
          type={buttons.length > 0 ? ButtonType.TERTIARY : ButtonType.PRIMARY}
        />
      </Buttons>
    </DefaultBarWrapper>
  );
}

const DefaultBarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 20%;

  width: 100%;

  padding: ${sizing.large} ${sizing.xlarge};

  background-color: ${colors.white.primary};

  border-top: 1px solid ${colors.grey.secondary};
  border-left: 1px solid ${colors.grey.secondary};
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sizing.medium};
`;

FooterButtons.propTypes = {
  backButton: PropTypes.shape({
    isDisabled: PropTypes.bool,
    name: PropTypes.string,
  }),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      handleClick: PropTypes.func,
      isDisabled: PropTypes.bool,
      loading: PropTypes.bool,
      name: PropTypes.string,
    }),
  ),
};

export default FooterButtons;
